<template>
    <main style="display: block;">
        <div class="scrollV" >
            <div style="padding: 1rem;" class="newFl" id="cust-scroll">
                <transition name="view" appear>
                    <div class="flex flex-col w-full mr-4">
                        <div class="mb-4 flex justify-between items-start">
                            <div class="flex items-end">
                                <h1 class="text-2xl leading-none text-black-1 mr-2">Approvals</h1>
                            </div>
                            <div style="display: flex; flex-flow: row wrap; justify-content: flex-end; align-content: right; text-align: right;">

                            </div>
                        </div>
                        <div class="c-table">
                            <table class="w-full mb-2 border-separate">
                                <thead>
                                <tr>
                                    <th v-for="column in columns"
                                        :key="column.name">
                                        <div class="flex items-center justify-center ">
                                            <span class="uppercase text-gray-1 text-sm" v-if="column.label">{{ column.label }}</span>
                                        </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody v-if="approvals.length === 0 && !isLoadingDept">
                                <tr class="mb-3 bg-white border border-solid border-gray-3 shadow-2l">
                                    <td class="p-5 font-bold" :colspan="columns.length">
                                        No Approvals Yet
                                    </td>
                                </tr>
                                </tbody>
                                <transition-group v-else tag="tbody" name="table-row">
                                    <tr :key="item.id" class="mb-3 bg-white border border-solid border-gray-3 shadow-2l"
                                        v-for="item in approvals">
                                        <td class="p-5" v-for="column in columns" :key="column.name">
                                            <template v-if="'actions' in column">
                                                <Button v-for="(action, index) in column.actions"
                                                        :key="index"
                                                        class="text-primary-normal hover:text-black-1 hover:bg-primary-light"
                                                        @click.native="action.function"
                                                        rounded>
                                                    View
                                                </Button>
                                            </template>
                                            <template v-else>
                                                <div v-if="column.name == 'type'" class="flex items-center justify-center">
                                                    <div>
                                                        <p class="text-center leading-tight">{{ item.appr_type }}</p>
                                                    </div>
                                                </div>
                                                <div v-if="column.name == 'status'" class="flex items-center justify-center">
                                                    <div>
                                                        <p class="text-center leading-tight" v-if="item.approved == null">Pending</p>
                                                        <p class="text-center leading-tight" style="color: #2ECC71;" v-if="item.approved == true && item.is_complete == false">Approved</p>
                                                        <p class="text-center leading-tight" style="color: #2ECC71;" v-if="item.approved == true && item.is_complete == true">Completed</p>
                                                        <p class="text-center leading-tight" style="color: #E74C3C;" v-if="item.approved == false">Declined</p>
                                                    </div>
                                                </div>
                                                <div v-if="column.name == 'date'" class="flex items-center justify-center">
                                                    <div>
                                                        <p class="text-center leading-tight">{{ item.date_created | dateFor }}</p>
                                                    </div>
                                                </div>
                                                <div v-if="column.name == 'action'" class="flex items-center justify-center">
                                                    <div>
                                                        <button style="color: #3498DB;" @click="viewAppr(item)">View</button>
                                                    </div>
                                                </div>
                                                <div v-if="column.name == 'action2' && item.approved == true && item.is_complete == false" class="flex items-center justify-center">
                                                    <div>
                                                        <button style="color: #2ECC71;" @click="checkComplete(item)">Complete</button>
                                                    </div>
                                                </div>
                                            </template>
                                        </td>
                                    </tr>
                                </transition-group>
                            </table>
                            <div v-if="isLoadingDept">
                                <div class="loading-animation" style="width: 100%; height: 60px;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <modal name="viewApprSignModal" :adaptive="true" width="620" :styles="{'background': '#EAFAF1', 'border-radius': '20px'}">
          <div class="tvv" v-if="apprModal.details != null">
            <!-- <h6><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(moreTData.amount) }}</h6> -->
            <h6 v-if="apprModal.details.is_deleted">Approve Deletion of Signatory</h6>
            <h6 v-if="!apprModal.details.is_deleted">Approve Creation of Signatory</h6>
            <h6><span style="color: #2ECC71;">Name:</span> {{ apprModal.details.signatory.first_name }} {{ apprModal.details.signatory.last_name }}</h6>
            <h6><span style="color: #2ECC71;">Username:</span> @{{ apprModal.details.signatory.username }}</h6>
            <h6><span style="color: #2ECC71;">Email:</span> {{ apprModal.details.signatory.email }}</h6>
          </div>
      </modal>
      <modal name="viewTransApprModal" :adaptive="true" width="620" :styles="{'background': '#EAFAF1', 'border-radius': '20px'}">
          <div class="tvv" v-if="transApprModal.details != null">
            <!-- <h6><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(moreTData.amount) }}</h6> -->
            <h3>Approve Transaction</h3>
            
            <h6><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(transApprModal.details.newTransaction.amount) }}</h6>
            <h6 v-if="transApprModal.details.busRecData.profile == null"><span style="color: #2ECC71;">Name:</span> {{ transApprModal.details.mainRecData.first_name }} {{ transApprModal.details.mainRecData.last_name }}</h6>
            <h6 v-if="transApprModal.details.busRecData.profile != null"><span style="color: #2ECC71;">Name:</span> {{ transApprModal.details.busRecData.profile.business_name }}</h6>
            <h6 v-if="transApprModal.details.busRecData.profile == null"><span style="color: #2ECC71;">Username:</span> @{{ transApprModal.details.mainRecData.username }}</h6>
            <h6 v-if="transApprModal.details.busRecData.profile == null"><span style="color: #2ECC71;">Email:</span> {{ transApprModal.details.mainRecData.email }}</h6>
            <h6 v-if="transApprModal.details.busRecData.profile != null"><span style="color: #2ECC71;">Username:</span> @{{ transApprModal.details.busRecData.username }}</h6>
            <h6 v-if="transApprModal.details.busRecData.profile != null"><span style="color: #2ECC71;">Email:</span> {{ transApprModal.details.busRecData.email }}</h6>
          </div>
      </modal>
      <modal name="viewBillApprModal" :adaptive="true" width="620" :styles="{'background': '#EAFAF1', 'border-radius': '20px'}">
          <div class="tvv" v-if="billApprModal.details != null">
            <!-- <h6><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(moreTData.amount) }}</h6> -->
            <h3 v-if="billApprModal.details.newTransaction.trans_type == 'AIRTIME'">Approve Airtime Purchase</h3>
            <h3 v-if="billApprModal.details.newTransaction.trans_type == 'DATA'">Approve Data Purchase</h3>
            <h3 v-if="billApprModal.details.newTransaction.trans_type == 'CABLE'">Approve Cable Subscription</h3>
            <h3 v-if="billApprModal.details.newTransaction.trans_type == 'ELECTRICITY'">Approve Electricity Topup</h3>
            
            <h6><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(billApprModal.details.newTransaction.amount) }}</h6>
            <h6 v-if="billApprModal.details.newTransaction.trans_type == 'AIRTIME'"><span style="color: #2ECC71;">Phone Number:</span> {{ billApprModal.details.info.to }}</h6>
            <h6 v-if="billApprModal.details.newTransaction.trans_type == 'DATA'"><span style="color: #2ECC71;">Phone Number:</span> {{ billApprModal.details.info.to }}</h6>
            <h6 v-if="billApprModal.details.newTransaction.trans_type == 'CABLE'"><span style="color: #2ECC71;">Smartcard Number:</span> {{ billApprModal.details.info.smartcard_number }}</h6>
            <h6 v-if="billApprModal.details.newTransaction.trans_type == 'ELECTRICITY'"><span style="color: #2ECC71;">Meter Number:</span> {{ billApprModal.details.info.meter_number }}</h6>
            <h6><span style="color: #2ECC71;">Bill Vendor:</span> {{ billApprModal.details.newTransaction.bill_vendor }}</h6>
          </div>
      </modal>
      <modal name="viewVoucherApprModal" :adaptive="true" width="620" :styles="{'background': '#EAFAF1', 'border-radius': '20px'}">
          <div class="tvv" v-if="voucherApprModal.details != null">
            <!-- <h6><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(moreTData.amount) }}</h6> -->
            <h3 v-if="voucherApprModal.details.type == 'CREATE'">Approve Voucher Creation</h3>
            <h3 v-if="voucherApprModal.details.type == 'EDIT'">Approve Voucher Update</h3>

            <h6><span style="color: #2ECC71;">Name:</span> {{ voucherApprModal.details.name }}</h6>
            <div v-if="voucherApprModal.details.createVoucherDetails != null">
              <h6 v-if="voucherApprModal.details.createVoucherDetails.is_amt == true"><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(voucherApprModal.details.createVoucherDetails.amount) }}</h6>
              <h6 v-if="voucherApprModal.details.createVoucherDetails.is_perc == true"><span style="color: #2ECC71;">Percentage:</span> {{ Intl.NumberFormat().format(voucherApprModal.details.createVoucherDetails.percentage) }}%</h6>
            </div>
            <div v-if="voucherApprModal.details.editVoucherModal != null">
              <h6 v-if="voucherApprModal.details.editVoucherModal.is_amt == true"><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(voucherApprModal.details.editVoucherModal.amount) }}</h6>
              <h6 v-if="voucherApprModal.details.editVoucherModal.is_perc == true"><span style="color: #2ECC71;">Percentage:</span> {{ Intl.NumberFormat().format(voucherApprModal.details.editVoucherModal.percentage) }}%</h6>
            </div>

          </div>
      </modal>
      <modal name="viewStaffApprModal" :adaptive="true" width="620" :styles="{'background': '#EAFAF1', 'border-radius': '20px'}">
          <div class="tvv" v-if="staffApprModal.details != null">
            <!-- <h6><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(moreTData.amount) }}</h6> -->
            <h3 v-if="staffApprModal.details.type == 'CREATE'">Approve Staff Linking</h3>
            <h3 v-if="staffApprModal.details.type == 'EDIT'">Approve Staff Update</h3>

            <h6><span style="color: #2ECC71;">Name:</span> {{ staffApprModal.details.userd.first_name }} {{ staffApprModal.details.userd.last_name }}</h6>
            <h6><span style="color: #2ECC71;">Staff Usnername:</span> @{{ staffApprModal.details.userd.username }}</h6>
            <h6><span style="color: #2ECC71;">Staff-link Usnername:</span> @{{ staffApprModal.details.new_staff.staff_username }}</h6>
            <h6 v-if="staffApprModal.details.new_staff.amount_taken == '0.00' && staffApprModal.details.new_staff.percentage_taken == '0.00'"><span style="color: #2ECC71;">Staff Type:</span> Salary</h6>
            <h6 v-if="staffApprModal.details.new_staff.amount_taken != '0.00' || staffApprModal.details.new_staff.percentage_taken != '0.00'"><span style="color: #2ECC71;">Staff Type:</span> Commission</h6>
            <h6 v-if="staffApprModal.details.new_staff.amount_taken != '0.00'"><span style="color: #2ECC71;">Commission Amount:</span> ₦{{ Intl.NumberFormat().format(staffApprModal.details.new_staff.amount_taken) }} </h6>
            <h6 v-if="staffApprModal.details.new_staff.percentage_taken != '0.00'"><span style="color: #2ECC71;">Commission Percentage:</span> {{ Intl.NumberFormat().format(staffApprModal.details.new_staff.percentage_taken) }}%</h6>

          </div>
      </modal>
      <modal name="viewWithdApprModal" :adaptive="true" width="620" :styles="{'background': '#EAFAF1', 'border-radius': '20px'}">
          <div class="tvv" v-if="withdApprModal.details != null">
            <h3>Approve Withdrawal to Bank</h3>
            
            <h6><span style="color: #2ECC71;">Amount:</span> ₦{{ Intl.NumberFormat().format(withdApprModal.details.new_transaction.amount) }}</h6>
            <h6><span style="color: #2ECC71;">Account Name:</span> {{ withdApprModal.details.info.beneficiaryAccountName }}</h6>
            <h6><span style="color: #2ECC71;">Account Number:</span> {{ withdApprModal.details.new_transaction.withdraw_bank_account }}</h6>
            <h6><span style="color: #2ECC71;">Bank Name:</span> {{ withdApprModal.details.new_transaction.bank_name_ben }}</h6>
          </div>
      </modal>
      <modal name="loadingAppModal" :clickToClose="false" :adaptive="true" width="120" height="120" :styles="{'border-radius': '20px'}">
        <div class="tvv2" style="display: flex; justify-content: center; align-items: center;">
          <div>
            <div class="page2" >
              <img id="rtt" class="qrClass" src="../../assets/img/loaders/loading.svg" alt="" width="64" height="64" style="text-align: center;">
            </div>
          </div>
        </div>
      </modal>
        <!-- <modal name="newSignModal" :adaptive="true" width="520" height="720" :styles="{'border-radius': '20px'}">
            <button @click="$modal.hide('newSignModal')" style="float: right; padding: 1rem;">
            ❌
            </button>
            <div class="tvv2">
            <div>
                <h3 class="bold-font" style="color: #0E6655; font-size: 25px;">Create New Signatory</h3>
                <form class="page2" @submit.prevent="checkSignatories()">
                    <label class="field field_v1" v-if="chosenSign.profile == null">
                      <input class="field__input" placeholder="e.g. johndoe or john@doe.com or +2348000000000" v-model="scust" required @keyup="searchUserS">
                      <span class="field__label-wrap">
                        <span class="field__label">Search User's Username or Email or Phone Number</span>
                      </span>
                    </label>
                    <div v-if="isLoadingUsers">
                      <div class="loading-animation" style="width: 90%; margin-top: 1rem; margin-left: 1rem;">
                          <span style="color: transparent">y</span>
                      </div>
                    </div>
                    <h4 v-if="nfo && !isLoadingUsers" style="color: red;">User Not Found</h4>
                    <div class="usersRow" v-if="options2.length > 0 && chosenSign.profile == null" v-for="(option) in options2" :key="option.id">
                        <div class="rS" style="display: flex; width: 80%">
                            <img :src="option.profile.profile_pic" class="avatar" alt="">
                            <div style="padding-left: .5rem; text-align: left;">
                                <h4>{{ option.first_name }} {{ option.last_name }}</h4> 
                                <p style="font-size: 15px;">@{{ option.username }}</p>
                            </div> 
                        </div>
                        <div class="rS" style="width: 20%; margin-top: .7rem;"> 
                            <button type="button" @click="chooseSign(option)" style="color: #2ECC71; font-weight: 600;">Choose</button>
                        </div>
                    </div>

                    <div class="usersRow" v-if="chosenSign.profile != null">
                        <div class="rS" style="display: flex; width: 80%">
                            <img :src="chosenSign.profile.profile_pic" class="avatar" alt="">
                            <div style="padding-left: .5rem; text-align: left;">
                                <h4>{{ chosenSign.first_name }} {{ chosenSign.last_name }}</h4> 
                                <p style="font-size: 15px;">@{{ chosenSign.username }}</p>
                            </div> 
                        </div>
                        <div class="rS" style="width: 20%; margin-top: .7rem;"> 
                            <button type="button" @click="clearChoice()" style="color: #2ECC71; font-weight: 600;">Change</button>
                        </div>
                    </div>

                    <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
                     :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                        <span style="text-align: center; font-weight: 800;" v-if="!isLoadingEditV">Confirm</span>
                        <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingEditV">
                    </Button> 
                </form>
            </div>
            </div>
        </modal> -->
        <v-dialog />
    </main>
</template>

<script>
  // import axios from "axios";
  import axios from '../../AxiosInstance.js';
  import router from "../../router";
  import Button from "../../components/Button";
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';

  var utc = require('dayjs/plugin/utc')
  var timezone = require('dayjs/plugin/timezone');

  dayjs.extend(utc);
  dayjs.extend(timezone);

  export default {
    name: "approvals",
    components: {
      Button,
    },
    data() {
      return {
        url: process.env.VUE_APP_BASE_URL,
        nodeurl: process.env.VUE_APP_NODE_URL,
        balance: localStorage.getItem("balance"),
        is_business: localStorage.getItem("is_business") == 'true' ? true : false,
        is_staff: localStorage.getItem("staff_username") ? true : false,
        businessName: localStorage.getItem("on_business_name"),
        deptCount: localStorage.getItem("department_count"),
        token: this.decrypt(localStorage.getItem("token")),
        user_id: this.decrypt(localStorage.getItem("user_id")),
        profile_id: this.decrypt(localStorage.getItem("profile_id")),
        has_signatory: this.decrypt(localStorage.getItem("has_signatory")),
        buttonType: 'submit', 
        signCount: 0,
        isLoading: false,
        isLoadingDept: false,
        isLoadingUsers: false,
        chosenSign: {},
        delSignModal: {},
        scust: null,
        signatories: [],
        approvals: [],
        apprModal: {},
        transApprModal: {},
        billApprModal: {},
        voucherApprModal: {},
        staffApprModal: {},
        withdApprModal: {},
        decSignModal: {},
        nextPage: null,
        avatarSize: 8,
        ammtt: true,
        freqq: false,
        neww: false,
        oldd: false,
        isLoadingDepartments: false,
        options: [],
        options2: [],
        nfo: false,
        isLoadingEditV: false,
        isDisabled: true,
        chosenDept: {},
        new_dept: {},
        columns: [
            {name: 'type', label: 'Type', required: true, sortable: false},
            {name: 'status', label: 'Status', required: true, sortable: false},
            {name: 'date', label: 'Date', required: true, sortable: false},
            {name: 'action', label: '', required: true, sortable: false},
            {name: 'action2', label: '', required: true, sortable: false},
            {name: 'action3', label: '', required: true, sortable: false},
        ],
      }
    },
    mounted() {
      this.checkLoggedIn();
      const listElm = document.querySelector('#cust-scroll');
      listElm.addEventListener('scroll', e => {
        if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          this.getMoreApprovals();
        }
      });
    },
    created() {
      document.title = "Zinger - Approvals";
      dayjs.extend(relativeTime);
    },
    filters: {
      diffForHumans: (date) => {
        if (!date){
            return null;
        }
        return dayjs.tz(date,"Europe/London").fromNow();
      },
      dateFor: (date) => {
        date = date.substring(0, date.indexOf("."))
        return dayjs(date).format('ddd, MMM D, YYYY h:mm A');
      },
      dateAs: (date) =>{
        if (!date){
            return null;
        }
        return dayjs(date).format('MM-DD-YYYY');
      }
    },
    methods: {
        checkLoggedIn() {
            if(!this.is_staff){
                if (!this.token) {
                    router.push({ name: "login", query: { redirect: "/approvals" } });
                }else if(this.decrypt(localStorage.getItem("verified_status")) == 'false'){
                    router.push("/verify");
                }else{
                  this.getApprovals();
                }
            }else{
                router.push("/");
            }
        },
        getApprovals(){
          this.isLoadingDept = true;
          axios.get(this.url + "api/v1/n-approvals/" + this.user_id + "/",
          { headers: { authorization: "Token " + this.token } }).then(response => {
            
            this.approvals = response.data.results;
            this.approvals.forEach(element => {
              // console.log(element);
              this.checkAppStatus(element);
            });
            if(response.data.links.next != null){
                this.nextPage = response.data.links.next;
            }else{
                this.nextPage = null;
            }
            // this.signCount = response.data.length;
            this.isLoadingDept = false;
            // console.log(this.approvals)
          }).catch(err => {
            // console.log(err)
            this.isLoadingDept = false;
          });
        },
        getMoreApprovals(){
            // console.log("more")
            if(this.nextPage != null){
                this.isLoadingDept = true;
                axios.get(this.nextPage,
                { headers: { authorization: "Token " + this.token } }).then(response => {
                    // console.log(response.data.results)
                    let tempC = response.data.results;
                    tempC.forEach(element => {
                      // console.log(element);
                      this.checkAppStatus(element);
                    });
                    let tempD = [...this.approvals,...tempC];

                    let result = tempD.filter(function (a) {
                        var key = a.id;
                        if (!this[key]) {
                            this[key] = true;
                        return true;
                        }
                    }, Object.create(null));
                    // console.log(result);
                    this.approvals = result;

                    if(response.data.links.next != null){
                        this.nextPage = response.data.links.next;
                    }else{
                        this.nextPage = null;
                    }
                    this.isLoadingDept = false;
                }).catch(err => {
                    this.isLoadingDept = false;
                    this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                });
            }
        },
        viewAppr(item){
          try{
            item.details = JSON.parse(item.details);
          }catch(e){

          }
          if(item.appr_type == 'SIGNATORY'){
            this.apprModal = item;
            this.$modal.show('viewApprSignModal');
          }else if(item.appr_type == 'TRANSFER'){
            this.transApprModal = item;
            this.$modal.show('viewTransApprModal');
          }else if(item.appr_type == 'BILL'){
            this.billApprModal = item;
            this.$modal.show('viewBillApprModal');
          }else if(item.appr_type == 'VOUCHER'){
            this.voucherApprModal = item;
            this.$modal.show('viewVoucherApprModal');
          }else if(item.appr_type == 'STAFF'){
            this.staffApprModal = item;
            this.$modal.show('viewStaffApprModal');
          }else if(item.appr_type == 'WITHDRAWAL'){
            this.withdApprModal = item;
            this.$modal.show('viewWithdApprModal');
          }
          
          // console.log(this.withdApprModal);
        },
        checkComplete(item){
          try{
            item.details = JSON.parse(item.details);
          }catch(e){

          }
          if(item.appr_type == 'SIGNATORY'){
            if(item.details.is_deleted){
              this.deleteSignatory(item);
            }else{
              this.crSignatory(item);
            }
          }else if(item.appr_type == 'TRANSFER'){
            this.completeTransfer(item);
          }else if(item.appr_type == 'BILL'){
            if(item.details.newTransaction.trans_type == 'AIRTIME'){
              this.buyAirtime(item);
            }else if(item.details.newTransaction.trans_type == 'DATA'){
              this.buyData(item);
            }else if(item.details.newTransaction.trans_type == 'CABLE'){
              this.buyCable(item);
            }else{
              this.buyElec(item);
            }
          }else if(item.appr_type == 'VOUCHER'){
            if(item.details.type == 'CREATE'){
              this.createVoucher(item);
            }else{
              this.editVoucher(item);
            }
          }else if(item.appr_type == 'STAFF'){
            if(item.details.type == 'CREATE'){
              this.createStaff(item);
            }else{
              this.editStaff(item);
            }
          }else if(item.appr_type == 'WITHDRAWAL'){
            this.completeWithdrawal(item);
          }
        },
        checkAppStatus(item){
          // console.log(item);
         let stat = item.approvaln.filter(el => {
              return el.approved == false;
          }); 
          // console.log(stat);
          let stat2 = item.approvaln.filter(el => {
              return el.approved == null;
          }); 
          if(stat.length > 0){
            item.approved = false;
          }else if(stat2.length > 0){
            item.approved = null;
          }else{
            item.approved = true;
          }
          
        },
        
        checkSignatories(){
          let self = this;
          this.isLoadingEditV = true;
          let new_sign = {};
          new_sign.business_id = this.user_id;
          new_sign.signatory_id = this.chosenSign.id;
          let count = 1;
          
          if(this.signatories.length != 0){
            let new_app = {};
            new_app.appr_type = "SIGNATORY";
            new_app.details = JSON.stringify(new_sign);
            new_app.business = this.user_id;
            axios.post(this.url + "api/v1/create-n-approval/", new_app,
            { headers: { authorization: "Token " + this.token } }).then(response => {
              this.signatories.forEach(element => {
                new_app.signatory = element.signatory.id;
                new_app.business = element.business.id;
                new_app.approval = response.data.id;
                axios.post(this.url + "api/v1/create-approval/", new_app,
                { headers: { authorization: "Token " + self.token } }).then(response => {
                  if(this.signatories.length == count){
                    this.isLoadingEditV = false;
                    this.scust = null;
                    this.$modal.hide('newSignModal');
                    this.$toast.info('Signatory Creation Initiated. Awaiting Validation.', {duration: 3000, position: "top-right"});
                  }else{
                    count++;
                  }
                }).catch(err => {
                  this.isLoadingEditV = false;
                  this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                });
              });
            }).catch(err => {
              this.isLoadingEditV = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          }else{
            axios.post(this.url + "api/v1/create-signatory/", new_sign,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              let tempD = [response.data];
              this.signatories = [...tempD,...this.signatories];
              this.isLoadingEditV = false;
              this.chosenSign = {};
              this.scust = null;
              localStorage.setItem('has_signatory', self.encrypt("true"));
              this.$modal.hide('newSignModal');
              this.$toast.success('Signatory Successfully Created.', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.isLoadingEditV = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          }
        },
        crSignatory(item){
          let self = this;
          // console.log(item);
          this.$modal.show('loadingAppModal');
          let new_sign = {};
          new_sign.business_id = self.user_id;
          new_sign.signatory_id = item.details.signatory.id;
          item.is_complete = true;

          axios.post(this.url + "api/v1/create-signatory/", new_sign,
          { headers: { authorization: "Token " + self.token } }).then(response => {
            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              localStorage.setItem('has_signatory', self.encrypt("true"));
              this.$modal.hide('loadingAppModal');
              this.$toast.success('Signatory Successfully Created.', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          }).catch(err => {
            this.$modal.hide('loadingAppModal');
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        },
        deleteSignatory(item){
          // console.log(item)
          let self = this;
          this.$modal.show('loadingAppModal');
          let del_dets = {};
          del_dets.id = item.details.signatory_id_main;
          del_dets.business_id = self.user_id;
          del_dets.signatory_id = item.details.signatory_id; 
          del_dets.is_deleted = true;
          item.is_complete = true;

          axios.put(this.url + "api/v1/signatory/" + del_dets.id + "/", del_dets,
          { headers: { authorization: "Token " + self.token } }).then(response => {
            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              this.$modal.hide('loadingAppModal');
              this.$toast.info('Signatory Deleted.', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          }).catch(err => {
            this.$modal.hide('loadingAppModal');
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        },
        createVoucher(item){
          let self = this;
          this.$modal.show('loadingAppModal');

          axios.post(this.url + "api/v1/create-voucher/", item.details.createVoucherDetails,
          { headers: { authorization: "Token " + self.token } }).then(response => {
            item.details.createVoucherDetails.business_giving_voucher_name = localStorage.getItem("business_name");
            item.details.createVoucherDetails.date = Math.floor(100000 + Math.random() * 900000);
            this.$root.$emit('newVoucher', item.details.createVoucherDetails);
            // item.details.createVoucherDetails = {is_amt: false, is_perc: true, exp_date: new Date().toISOString()},
            item.is_complete = true;
            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              this.$modal.hide('loadingAppModal');
              this.$toast.info('Voucher Created', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          }).catch(err => {
            this.$modal.hide('loadingAppModal');
            if(err.response){
              if(err.response.data.amount || err.response.data.percentage){
                this.$toast.error('Ensure this value is greater than or equal to 0.1', {duration: 5000, position: "top-right"});
              }
            }else{
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            }
          });
        },
        editVoucher(item){
          let self = this;
          this.$modal.show('loadingAppModal');

          axios.put(this.url + "api/v1/voucher/" + item.details.editVoucherModal.id + "/", item.details.editVoucherModal,
          { headers: { authorization: "Token " + self.token } }).then(response => {
            item.is_complete = true;
            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              this.$modal.hide('loadingAppModal');
              this.$toast.info('Voucher Edited', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          }).catch(err => {
              this.$modal.hide('loadingAppModal');
              if(err.response){
              if(err.response.data.amount || err.response.data.percentage){
                  this.$toast.error('Ensure this value is greater than or equal to 0.1', {duration: 5000, position: "top-right"});
                }
              }else{
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
              }
          });
        },
        createStaff(item){
          let self =this;
          this.$modal.show('loadingAppModal');

          axios.post(this.url + "api/v1/create-staff/", item.details.new_staff,
          { headers: { authorization: "Token " + self.token } }).then(response => {
            item.is_complete = true;
            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              this.$modal.hide('loadingAppModal');
              this.$toast.success('Staff Successfully Created.', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          }).catch(err => {
              this.$modal.hide('loadingAppModal');
              if(err.response){
                // console.log(err.response.data)
                if(err.response.data.staff_username){
                  this.$toast.error('Username already exists. Username must be unique', {duration: 5000, position: "top-right"});
                }
                if(err.response.data.amount_taken || err.response.data.percentage_taken){
                  this.$toast.error('Ensure this value is greater than or equal to 0.1', {duration: 5000, position: "top-right"});
                }
              }else{
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
              }
          });
        },
        editStaff(item){
          let self = this;
          this.$modal.show('loadingAppModal');
          
          axios.put(this.url + "api/v1/staff/" + item.details.new_staff.id + "/", item.details.new_staff,
          { headers: { authorization: "Token " + self.token } }).then(response => {
            item.is_complete = true;
            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              this.$modal.hide('loadingAppModal');
              this.$toast.info('Staff Details Updated.', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });              
          }).catch(err => {
              this.$modal.hide('loadingAppModal');
              if(err.response){
                if(err.response.data.amount_taken || err.response.data.percentage_taken){
                  this.$toast.error('Ensure this value is greater than or equal to 0.1', {duration: 5000, position: "top-right"});
                }
              }else{
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
              }
          });
        },
        completeWithdrawal(item){
          let self = this;
          this.$modal.show('loadingAppModal');

          // axios.put(this.url + "api/v1/update-sender-balance/" + this.profile_id + "/", item.details.senderDetails,
          // { headers: { authorization: "Token " + self.token } }).then(response => {
            // console.log(response.data);
            // localStorage.setItem("balance", response.data.balance);
            // this.balance = response.data.balance;
            // item.details.new_transaction.balance_after_trans_sender = response.data.balance;

            // axios.post(this.url + "api/v1/create-transaction/", item.details.new_transaction,
            // { headers: { authorization: "Token " + self.token } }).then(response2 => {
              // console.log(response2.data);

              // item.details.info.transactionReference = response2.data.reference;
              item.details.info.senderDetails = item.details.senderDetails;
              item.details.info.newTransaction = item.details.new_transaction;
              item.details.info.token = self.token;

              axios.post(this.nodeurl + "transfer-to-bank", item.details.info).then(message => {
                // console.log(message.data);
                if(message.data.message.responseCode == "00"){
                  // console.log(message.data);
                  item.is_complete = true;
                  axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
                  { headers: { authorization: "Token " + self.token } }).then(response => {
                    this.$modal.hide('loadingAppModal');
                    this.$toast.success('Transfer Successful.', {duration: 3000, position: "top-right"});
                  }).catch(err => {
                    this.$modal.hide('loadingAppModal');
                    this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                  });
                  // router.push("/");
                }else{

                  let rn = parseInt(localStorage.getItem('rn')) + 1;
                  let ammmtt = item.details.senderDetails;
                  let qrData = {amount: ammmtt, rn: rn};
                  let encData = self.CryptoJS.AES.encrypt(JSON.stringify(qrData), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

                  let receiverDetails = {};
                  receiverDetails.id = self.profile_id;
                  receiverDetails.user_id = self.user_id;
                  receiverDetails.tttdx = encData;

                  this.$modal.hide('loadingAppModal');

                  this.$toast.error('Error Completing Transfer.', {duration: 3000, position: "top-right"});
                }
              }).catch(err => {
                // console.log(err);

                // axios.put(this.url + "api/v1/update-receiver-refund-balance/" + item.details.receiverDetails.id + "/", item.details.receiverDetails,
                // { headers: { authorization: "Token " + self.token } }).then(response2 => {
                //   // console.log(response2)
                //   localStorage.setItem("balance", response2.data.balance);
                //   this.balance = response2.data.balance;
                //   this.$modal.hide('loadingAppModal');
                // }).catch(err2 => {
                // });
                this.$modal.hide('loadingAppModal');
                this.$toast.error('Error. Please make sure the bank account is linked to your BVN.', {duration: 3000, position: "top-right"});
              })
            // }).catch(err => {
            //   // console.log(err);
            //   this.$modal.hide('loadingAppModal');
            //   this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            // });

          // }).catch(err => {
          //   // console.log(err);
          //   this.$modal.hide('loadingAppModal');
          //   if(err.response){
          //     if(err.response.data.amount){
          //       this.$toast.error('Error. Invalid Amount', {duration: 3000, position: "top-right"});
          //     }else{
          //       localStorage.setItem("balance", err.response.data.balance.balance);
          //       this.balance = err.response.data.balance.balance;
          //       this.$toast.error('Error. Insufficient Funds', {duration: 3000, position: "top-right"});
          //     }
          //   }else{
          //     this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          //   }
          // });
        },
        buyAirtime(item){
          let self = this;
          this.$modal.show('loadingAppModal');

          item.details.senderDetails.amtt2 = item.details.info.amount;
          item.details.senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

          let encData = this.CryptoJS.AES.encrypt(JSON.stringify(item.details.senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();
          item.details.info.senderDetails = encData;
          item.details.info.newTransaction = item.details.newTransaction;
          item.details.info.token = self.token;

          axios.post(this.nodeurl + "new-airtime", item.details.info).then(message => {
            // console.log(message)
            item.is_complete = true;

            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              this.$modal.hide('loadingAppModal');
              this.$toast.success('Airtime Successfully Purchased.', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });

          }).catch(err => {
            this.$modal.hide('loadingAppModal');
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            localStorage.setItem('rn', rn);
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });

        },
        buyData(item){
          let self = this;
          this.$modal.show('loadingAppModal');

          item.details.senderDetails.variation_id = item.details.info.variation_id;
          item.details.senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

          let encData = this.CryptoJS.AES.encrypt(JSON.stringify(item.details.senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();
          item.details.info.senderDetails = encData;
          item.details.info.newTransaction = item.details.newTransaction;
          item.details.info.token = self.token;

          axios.post(this.nodeurl + "new-data", item.details.info).then(message => {
            // console.log(message)
            item.is_complete = true;

            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              this.$modal.hide('loadingAppModal');
              this.$toast.success('Data Successfully Purchased.', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
              
          }).catch(err => {
            this.$modal.hide('loadingAppModal');
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            localStorage.setItem('rn', rn);
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });

        },
        buyCable(item){
          let self = this;
          this.$modal.show('loadingAppModal');

          item.details.senderDetails.variation_id = item.details.info.variation_id;
          item.details.senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

          let encData = this.CryptoJS.AES.encrypt(JSON.stringify(item.details.senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();
          item.details.info.senderDetails = encData;
          item.details.info.newTransaction = item.details.newTransaction;
          item.details.info.token = self.token;

          axios.post(this.nodeurl + "new-cable", item.details.info).then(message => {
            // console.log(message)
            item.is_complete = true;

            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              this.$modal.hide('loadingAppModal');
              this.$toast.success('Cable Successfully Subscribed.', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
              
          }).catch(err => {
            this.$modal.hide('loadingAppModal');
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            localStorage.setItem('rn', rn);
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });

        },
        buyElec(item){
          let self = this;
          this.$modal.show('loadingAppModal');

          item.details.senderDetails.variation_id = item.details.info.variation_id;
          item.details.senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

          let encData = this.CryptoJS.AES.encrypt(JSON.stringify(item.details.senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();
          item.details.info.senderDetails = encData;
          item.details.info.newTransaction = item.details.newTransaction;
          item.details.info.token = self.token;

          axios.post(this.nodeurl + "new-elec", item.details.info).then(message => {
            // console.log(message)
            item.is_complete = true;

            axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              this.$modal.hide('loadingAppModal');
              this.$toast.success('Electricity Successfully Topped Up.', {duration: 3000, position: "top-right"});
            }).catch(err => {
              this.$modal.hide('loadingAppModal');
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
              
          }).catch(err => {
            this.$modal.hide('loadingAppModal');
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            localStorage.setItem('rn', rn);
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });

        },
        searchUserS(){
          let self = this;
          if(this.scust != null && this.scust != '' && this.scust != ' '){
              this.isLoadingUsers = true;
              axios.get(this.url + "api/v1/users/?search=" + this.scust,
              { headers: { authorization: "Token " + self.token } }).then(response => {
                  this.options2 = response.data.results.filter(el => {
                    return el.id != self.user_id && el.profile.is_business == false;
                  });
                  // console.log(this.options)
                  if(response.data.total == 0 || this.options2.length == 0){
                      this.nfo = true;
                      this.options2 = [];
                  }else{
                      this.nfo = false;
                  }
                  this.isLoadingUsers = false;
              }).catch(err => {
                  // console.log(err)
                  this.isLoadingUsers = false;
              });
          }else{
              this.options2 = [];
          }
        },
	completeTransfer(item){
          let self = this;
          this.$modal.show('loadingAppModal');

          item.details.senderDetails.rec_id = item.details.receiverDetails.id;

          axios.put(this.url + "api/v1/update-balances/" + this.profile_id + "/", item.details.senderDetails,
          { headers: { authorization: "Token " + self.token } }).then(response => {
            // console.log(response.data);
            localStorage.setItem("balance", response.data.balance);
            item.details.newTransaction.balance_after_trans_sender = response.data.balance;

            // axios.put(this.url + "api/v1/update-receiver-balance/" + item.details.receiverDetails.id + "/", item.details.receiverDetails,
            // { headers: { authorization: "Token " + self.token } }).then(response2 => {
              item.details.newTransaction.balance_after_trans_receiver = response.data.user_id;

                axios.post(this.url + "api/v1/create-transaction/", item.details.newTransaction,
                { headers: { authorization: "Token " + self.token } }).then(response3 => {
                  
                  if(item.details.newTransaction.amount >= 1000){
                    if(item.details.busRecData.profile != null){
                      let busTrans = {};
                      busTrans.sender = item.details.busRecData.id;
                      busTrans.amount = 10.00;
                      busTrans.trans_type = "CHARGES"

                      axios.post(this.url + "api/v1/create-transaction/", busTrans,
                      { headers: { authorization: "Token " + self.token } }).then(response9 => {
                      }).catch(err9 => {
                      });
                    }else{
                      if(item.details.mainRecData.profile.is_business || item.details.mainRecData.profile.is_upgraded){
                        let busTrans = {};
                        busTrans.sender = item.details.mainRecData.id;
                        busTrans.amount = 10.00;
                        busTrans.trans_type = "CHARGES"

                        axios.post(this.url + "api/v1/create-transaction/", busTrans,
                        { headers: { authorization: "Token " + self.token } }).then(response9 => {
                        }).catch(err9 => {
                        });
                      }
                    }
                  }

                  if(item.details.busRecData.profile != null){
                    if(item.details.busRecData.has_bought == false){
                      let boughtdata = {};
                      boughtdata.buying_user_id = self.user_id;
                      boughtdata.business_bought_from = item.details.busRecData.id;

                      axios.post(this.url + "api/v1/create-has-bought/", boughtdata,
                      { headers: { authorization: "Token " + self.token } }).then(response9 => {

                      }).catch(err9 => {

                      });
                    }
                    let text = {
                      message: '@' + localStorage.getItem("username") + ' sent ' + Intl.NumberFormat().format(item.details.newTransaction.amount) + ' Naira to ' + item.details.busRecData.profile.business_name + ' via your channel, @' + item.details.staffRecData.staff_username + '.',
                      to: item.details.mainRecData.profile.phone_number
                    }
                    axios.post(this.nodeurl + "new-trans-alert", text).then(message => {
                    }).catch(err => {
                    });
                  }else{
                    if(item.details.mainRecData.profile.is_business == true && item.details.mainRecData.has_bought == false){
                      let boughtdata = {};
                      boughtdata.buying_user_id = self.user_id;
                      boughtdata.business_bought_from = this.mainRecData.id;

                      axios.post(this.url + "api/v1/create-has-bought/", boughtdata,
                      { headers: { authorization: "Token " + self.token } }).then(response9 => {

                      }).catch(err9 => {

                      });
                    }
                  }

                  if(item.details.voucherDetails.id != null){
                    item.details.voucherDetails.is_completed = true;
                    item.details.voucherDetails.business_giving_voucher_id = item.details.voucherDetails.business_giving_voucher.id;
                    item.details.voucherDetails.voucher_given_user_id = item.details.voucherDetails.voucher_given_user.id;
                    axios.put(this.url + "api/v1/voucher/" + item.details.voucherDetails.id + "/", item.details.voucherDetails,
                    { headers: { authorization: "Token " + self.token } }).then(response2 => {
                      
                      if(parseFloat(item.details.staffRecData.percentage_taken) > 0 || parseFloat(item.details.staffRecData.amount_taken) > 0){
                        let senderBusiness = {};
                        senderBusiness.id = item.details.busRecData.profile.id;
                        senderBusiness.user_id = item.details.busRecData.id;
                        senderBusiness.rec_id = item.details.staffRecData.staff.profile.id;

                        let receiverStaff = {};
                        receiverStaff.id = item.details.staffRecData.staff.profile.id;
                        receiverStaff.user_id = item.details.staffRecData.staff.id;

                        let newStaffTransaction = {};
                        newStaffTransaction.sender = item.details.busRecData.id;
                        newStaffTransaction.receiver = item.details.staffRecData.staff.id;
                        newStaffTransaction.trans_type = "COMMISSION";

                        if(parseFloat(item.details.staffRecData.percentage_taken) > 0){
                          let percAmount = item.details.sendAmount * (parseFloat(item.details.staffRecData.percentage_taken) / 100);
                          senderBusiness.amount = parseFloat(percAmount).toFixed(2);
                          receiverStaff.amount = parseFloat(percAmount).toFixed(2);
                          newStaffTransaction.amount = parseFloat(percAmount).toFixed(2);
                        }else if(parseFloat(item.details.staffRecData.amount_taken) > 0){
                          if(parseFloat(item.details.busRecData.profile.balance) > parseFloat(item.details.staffRecData.amount_taken)){
                            senderBusiness.amount = parseFloat(item.details.staffRecData.amount_taken).toFixed(2);
                            receiverStaff.amount = parseFloat(item.details.staffRecData.amount_taken).toFixed(2);
                            newStaffTransaction.amount = parseFloat(item.details.staffRecData.amount_taken).toFixed(2);
                          }else{
                            senderBusiness.amount = 0;
                            receiverStaff.amount = 0;
                            newStaffTransaction.amount = 0;
                          }
                        }

                        axios.put(this.url + "api/v1/update-balances/" + senderBusiness.id + "/", senderBusiness,
                        { headers: { authorization: "Token " + self.token } }).then(response5 => {
                          newStaffTransaction.balance_after_trans_sender = response5.data.balance;
                          // axios.put(this.url + "api/v1/update-receiver-balance/" + receiverStaff.id + "/", receiverStaff,
                          // { headers: { authorization: "Token " + self.token } }).then(response6 => {
                            newStaffTransaction.balance_after_trans_receiver = response5.data.user_id;
                            axios.post(this.url + "api/v1/create-transaction/", newStaffTransaction,
                            { headers: { authorization: "Token " + self.token } }).then(response7 => {

                              if(newStaffTransaction.amount >= 1000){
                                if(item.details.staffRecData.staff.profile.is_business || item.details.staffRecData.staff.profile.is_upgraded){
                                  let busTrans = {};
                                  busTrans.sender = item.details.staffRecData.staff.id;
                                  busTrans.amount = 10.00;
                                  busTrans.trans_type = "CHARGES";

                                  axios.post(this.url + "api/v1/create-transaction/", busTrans,
                                  { headers: { authorization: "Token " + self.token } }).then(response9 => {
                                  }).catch(err9 => {
                                  });
                                }
                              }
                              // console.log(response3);

                              item.details.newTransaction.sender_username = localStorage.getItem("username");
                              newStaffTransaction.sender_username = localStorage.getItem("username");
                              item.details.newTransaction.date = Math.floor(100000 + Math.random() * 900000);
                              newStaffTransaction.date = Math.floor(100000 + Math.random() * 900000);
                              this.$root.$emit('newTrans', item.details.newTransaction);
                              this.$root.$emit('newStaffTrans', newStaffTransaction);
                              if(item.details.staffRecData.accept_tip && self.has_signatory == 'false'){
                                item.details.mainRecData.issSt = true;
                                this.$modal.show("tip2QModal");
                              }else{
                                item.is_complete = true;
                                axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
                                { headers: { authorization: "Token " + self.token } }).then(response => {
                                  this.$modal.hide('loadingAppModal');
                                  this.transApprModal = {};
                                  this.$toast.success('Transaction Successful.', {duration: 3000, position: "top-right"});
                                }).catch(err => {
                                  console.log(err)
                                  this.$modal.hide('loadingAppModal');
                                  this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                                });
                              }
                            }).catch(err => {
                              console.log(err)
                            // console.log(err);
                              this.$modal.hide('loadingAppModal');
                              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                            });
                          // }).catch(err => {
                          //   console.log(err)
                          //   // console.log(err);
                          //   this.$modal.hide('loadingAppModal');
                          //   this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                          // });
                        }).catch(err => {
                          console.log(err)
                          // console.log(err);
                          this.$modal.hide('loadingAppModal');
                          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                        });
                      }else{

                        item.details.newTransaction.sender_username = localStorage.getItem("username");
                        newTransaction.date = Math.floor(100000 + Math.random() * 900000);
                        this.$root.$emit('newTrans', item.details.newTransaction);
                        // this.$modal.hide('pin2BModal');
                        if(item.details.staffRecData.accept_tip && self.has_signatory == 'false'){
                          item.details.mainRecData.issSt = true;
                          this.$modal.show("tip2QModal");
                        }else{
                          item.is_complete = true;
                          axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
                          { headers: { authorization: "Token " + self.token } }).then(response => {
                            this.$modal.hide('loadingAppModal');
                            this.transApprModal = {};
                            this.$toast.success('Transaction Successful.', {duration: 3000, position: "top-right"});
                          }).catch(err => {
                            console.log(err)
                            this.$modal.hide('loadingAppModal');
                            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                          });
                        }
                      }
                    }).catch(err => {
                      // console.log(err);
                      this.$modal.hide('loadingAppModal');
                      this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"})
                    });
                  }else{
                    if(parseFloat(item.details.staffRecData.percentage_taken) > 0 || parseFloat(item.details.staffRecData.amount_taken) > 0){
                      let senderBusiness = {};
                      senderBusiness.id = item.details.busRecData.profile.id;
                      senderBusiness.user_id = item.details.busRecData.id;
                      senderBusiness.rec_id = item.details.staffRecData.staff.profile.id;

                      let receiverStaff = {};
                      receiverStaff.id = item.details.staffRecData.staff.profile.id;
                      receiverStaff.user_id = item.details.staffRecData.staff.id;

                      let newStaffTransaction = {};
                      newStaffTransaction.sender = item.details.busRecData.id;
                      newStaffTransaction.receiver = item.details.staffRecData.staff.id;
                      newStaffTransaction.trans_type = "COMMISSION";

                      if(parseFloat(item.details.staffRecData.percentage_taken) > 0){
                        let percAmount = receiverDetails.amount * (parseFloat(item.details.staffRecData.percentage_taken) / 100);
                        senderBusiness.amount = parseFloat(percAmount).toFixed(2);
                        receiverStaff.amount = parseFloat(percAmount).toFixed(2);
                        newStaffTransaction.amount = parseFloat(percAmount).toFixed(2);
                      }else if(parseFloat(item.details.staffRecData.amount_taken) > 0){
                        if(parseFloat(item.details.busRecData.profile.balance) > parseFloat(item.details.staffRecData.amount_taken)){
                          senderBusiness.amount = parseFloat(item.details.staffRecData.amount_taken).toFixed(2);
                          receiverStaff.amount = parseFloat(item.details.staffRecData.amount_taken).toFixed(2);
                          newStaffTransaction.amount = parseFloat(item.details.staffRecData.amount_taken).toFixed(2);
                        }else{
                          senderBusiness.amount = 0;
                          receiverStaff.amount = 0;
                          newStaffTransaction.amount = 0;
                        }
                      }

                      axios.put(this.url + "api/v1/update-balances/" + senderBusiness.id + "/", senderBusiness,
                      { headers: { authorization: "Token " + self.token } }).then(response5 => {
                        newStaffTransaction.balance_after_trans_sender = response5.data.balance;
                        // axios.put(this.url + "api/v1/update-receiver-balance/" + receiverStaff.id + "/", receiverStaff,
                        // { headers: { authorization: "Token " + self.token } }).then(response6 => {
                          newStaffTransaction.balance_after_trans_receiver = response5.data.user_id;
                          axios.post(this.url + "api/v1/create-transaction/", newStaffTransaction,
                          { headers: { authorization: "Token " + self.token } }).then(response3 => {
                            if(newStaffTransaction.amount >= 1000){
                              if(item.details.staffRecData.staff.profile.is_business || item.details.staffRecData.staff.profile.is_upgraded){
                                let busTrans = {};
                                busTrans.sender = item.details.staffRecData.staff.id;
                                busTrans.amount = 10.00;
                                busTrans.trans_type = "CHARGES";

                                axios.post(this.url + "api/v1/create-transaction/", busTrans,
                                { headers: { authorization: "Token " + self.token } }).then(response9 => {
                                }).catch(err9 => {
                                });
                              }
                            }
                            // console.log(response3);
                            item.details.newTransaction.sender_username = localStorage.getItem("username");
                            newStaffTransaction.sender_username = localStorage.getItem("username");
                            item.details.newTransaction.date = Math.floor(100000 + Math.random() * 900000);
                            newStaffTransaction.date = Math.floor(100000 + Math.random() * 900000);
                            this.$root.$emit('newTrans', item.details.newTransaction);
                            this.$root.$emit('newStaffTrans', newStaffTransaction);
                            if(item.details.staffRecData.accept_tip && self.has_signatory == 'false'){
                              item.details.mainRecData.issSt = true;
                              this.$modal.show("tip2QModal");
                            }else{
                              item.is_complete = true;
                              axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
                              { headers: { authorization: "Token " + self.token } }).then(response => {
                                this.$modal.hide('loadingAppModal');
                                this.transApprModal = {};
                                this.$toast.success('Transaction Successful.', {duration: 3000, position: "top-right"});
                              }).catch(err => {
                                console.log(err)
                                this.$modal.hide('loadingAppModal');
                                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                              });
                            }
                          }).catch(err => {
                          // console.log(err);
                            this.$modal.hide('loadingAppModal');
                            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                          });
                        // }).catch(err => {
                        //   // console.log(err);
                        //   this.$modal.hide('loadingAppModal');
                        //   this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"})
                        // });
                      }).catch(err => {
                        // console.log(err);
                        this.$modal.hide('loadingAppModal');
                        this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"})
                      });
                    }else{

                      item.details.newTransaction.sender_username = localStorage.getItem("username");
                      item.details.newTransaction.date = Math.floor(100000 + Math.random() * 900000);
                      this.$root.$emit('newTrans', item.details.newTransaction);
                      // this.$modal.hide('pin2BModal');
                      if(item.details.staffRecData.accept_tip && self.has_signatory == 'false'){
                        item.details.mainRecData.issSt = true;
                        this.$modal.show("tip2QModal");
                      }else{
                        item.is_complete = true;
                        axios.put(this.url + "api/v1/n-approval/" + item.id + "/", item,
                        { headers: { authorization: "Token " + self.token } }).then(response => {
                          this.$modal.hide('loadingAppModal');
                          this.transApprModal = {};
                          this.$toast.success('Transaction Successful.', {duration: 3000, position: "top-right"});
                        }).catch(err => {
                          console.log(err)
                          this.$modal.hide('loadingAppModal');
                          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                        });
                      }
                    }
                  }
              }).catch(err => {
                console.log(err);
                this.$modal.hide('loadingAppModal');
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"})
              });
            // }).catch(err => {
            //   console.log(err)
            //   // console.log(err);
            //   this.$modal.hide('loadingAppModal');
            //   this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"})
            // });
          }).catch(err => {
            this.$modal.hide('loadingAppModal');
            console.log(err)
            if(err.response){
              if(err.response.data.amount){
                this.$toast.error('Error. Invalid Amount', {duration: 3000, position: "top-right"});
              }else{
                localStorage.setItem("balance", err.response.data.balance.balance);
                this.balance = err.response.data.balance.balance;
                this.$toast.error('Error. Insufficient Funds', {duration: 3000, position: "top-right"});
              }
            }else{
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            }
          });
        },
        openAprrSign(sign){
            this.decSignModal = sign;
            this.$modal.show('dialog', {
            title: 'Approve Request',
            text: 'Are you sure?',
            buttons: [
                {
                    title: 'Cancel',
                    handler: () => {
                        this.$modal.hide('dialog')
                    }
                },
                {
                    title: 'Approve',
                    handler: () => {
                        this.approveSignatory()
                    }
                }
            ]
            })
        },
        openDeleteAppr(sign){
            this.decSignModal = sign;
            this.$modal.show('dialog', {
            title: 'Decline Request',
            text: 'Are you sure?',
            buttons: [
                {
                    title: 'Cancel',
                    handler: () => {
                        this.$modal.hide('dialog')
                    }
                },
                {
                    title: 'Decline',
                    handler: () => {
                        this.declineSignatory()
                    }
                }
            ]
            })
        },
        declineSignatory(){
          let self = this;
          this.decSignModal.approved = false;

          axios.put(this.url + "api/v1/approval/" + this.decSignModal.id + "/", this.decSignModal,
          { headers: { authorization: "Token " + self.token } }).then(response => {
            this.decSignModal = {};
            this.$modal.hide('dialog');
            this.$toast.info('Approval Denied.', {duration: 3000, position: "top-right"});
          }).catch(err => {
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        },
        approveSignatory(){
          let self = this;
          this.decSignModal.approved = true;

          axios.put(this.url + "api/v1/approval/" + this.decSignModal.id + "/", this.decSignModal,
          { headers: { authorization: "Token " + self.token } }).then(response => {
            this.decSignModal = {};
            this.$modal.hide('dialog');
            this.$toast.success('Approval Granted.', {duration: 3000, position: "top-right"});
          }).catch(err => {
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        },
        chooseSign(sign){
          this.chosenSign = sign;
        },
        clearChoice(){
          this.chosenSign = {};
        },
        viewDept(dept){
          localStorage.setItem("depttb_id", dept.id);
          router.push("/departments/" + dept.name);
        },
    }
  }
</script>

<style lang="css" scoped>
.scrollV{
    display: flex;
    flex-direction: column;
    height: calc(100vh - 117px);
}

select{
  background: transparent url("data:image/svg+xml;utf8,<svg style='float: right;' width='24' height='24' class='w-6 h-6' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'></path></svg>") no-repeat;
  background-position: right 5px top 50%;
}

.newFl{
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 30px;
  scroll-behavior: smooth;
}

.usersRow{
  display: flex;
  flex-flow: row wrap;
  align-content: stretch;
  padding: 1rem;
}

.rS {
  width: 100%;
}

.rowrapper{
  display: flex;
  flex-flow: row wrap;
  /* justify-content: center; */
  align-content: stretch;
}
@media screen and (max-width: 378px){
  .rowrapper{
    justify-content: center;
  }
}

.voucherRow{
  display: flex;
  flex-flow: row wrap;
  align-content: stretch;
  padding: 1rem;
}

.rS {
  width: 100%;
  /* flex: 1 1 0rem; */
}

.avatar {
  vertical-align: middle;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.balD{
  background: #2ECC71; 
  padding-bottom: 1rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  max-height: 115px;
  max-width: 500px;
}
.dtss{
  background: #000000; 
  padding-bottom: 1rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  margin-bottom: 1rem;
  border-radius: 10px;
  max-height: 115px;
  min-width: 200px;
  max-width: 500px;
}
.btnsD {
  height: 100px;
  width: 100px;
  /* margin-top: .5rem; */
  margin-left: 3rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  cursor: pointer;
  /* text-align: center; */
}
.trTbl{
  background: #ffffff; 
  padding-bottom: 1rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  height: 300px;
  width: 100%;
  margin-top: 5.5rem;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* padding-bottom: 30px; */
  scroll-behavior: smooth;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 33px 100px;

}
.btnsD:hover{
  background: #EAFAF1 !important;
}
.btnsTxt{
  margin-top: .2rem;
  margin-left: 3rem;
}
.btnsSvg{
  padding: 1.5rem;
}
h1, h2, h3, h4, h5, h6 {
    letter-spacing: -.5px;
    line-height: 1.4;
    margin: 5px 0;
    font-weight: 600;
    font-family: "CW BR Firma",sans-serif;
}
sup{
  vertical-align: middle;
  font-size: .43em;
  font-weight: 400;
  top: -.62em;
}
sub{
    bottom: .05em;
    margin-left: -4px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0;
    opacity: 1;
    font-size: .4em;
}
@media screen and (max-width: 600px){
  .balH{
    font-size: 2.0rem !important;
  }
}
@media screen and (max-width: 350px){
  .balH{
    font-size: 1.7rem !important;
  }
}
@media screen and (max-width: 453px){
  .balD{
    margin-bottom: 1rem;
  }
}

a{
  font-weight: 600;
  font-family: "CW BR Firma",sans-serif;
  color: #2ECC71;
}

#ahov:hover{
  color: #82E0AA;
}

.bold-font{
  font-weight: 700;
}

.js-pscroll {
  position: relative;
  overflow: hidden;
}


.table100 .ps__rail-x {
  z-index: 1010;
  height: 6px;
  background-color: transparent;
  opacity: 1 !important;
  bottom: 10px;
}

.table100 .ps__rail-x::before {
  content: "";
  display: block;
  position: absolute;
  background-color: #e6e6e6;
  height: 100%;
  width: calc(100% - 30px);
  left: 15px;
  top: 0px;
}

.table100 .ps__rail-x .ps__thumb-x {
  height: 100%;
  bottom: 0;
  background-color: transparent;
  opacity: 1 !important;
}

.table100 .ps__rail-x .ps__thumb-x::before {
  content: "";
  display: block;
  position: absolute;
  background-color: #b3b3b3;
  height: 100%;
  width: calc(100% - 30px);
  top: 0;
  left: 15px;
}


/*//////////////////////////////////////////////////////////////////
[ Table ]*/

.container-table100 {
  /* margin: 0 auto; */
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;

  background: #ffffff; 
  padding-bottom: 1rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  height: 300px;
  /* width: calc(90vw - 117px); */
  width: 100%;
  
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* padding-bottom: 30px; */
  scroll-behavior: smooth;
  display: flex;
  flex-wrap: wrap;
  /* align-items: center;
  justify-content: center; */
  /* padding: 33px 100px; */
}

.wrap-table100 {
  width: 100%;
}

/*//////////////////////////////////////////////////////////////////
[ Table ]*/
.table100 {
  background-color: #fff;
}

table {
  width: 100%;
}

th, td {
  /* font-weight: unset; */
  padding-right: 10px;
}

.column1 {
  width: 100%;
  padding-left: 40px;
}

.column2 {
  width: 225px;
  padding-left: 55px;
}

.column3 {
  width: 105px;
}

.column4 {
  width: 195px;
}

.column5 {
  width: 235px;
}

.column6 {
  width: 170px;
}

.column7 {
  width: 330px;
}

.column8 {
  width: 305px;
}

.table100 th {
  padding-top: 21px;
  padding-bottom: 21px;
}

.table100 td {
  padding-top: 16px;
  padding-bottom: 16px;
}


/*==================================================================
[ Fix col ]*/
.table100 {
  width: 100%;
  position: relative;
}

.table100-firstcol {
  background-color: #fff;
  position: absolute;
  z-index: 1000;
  width: 310px;
  top: 0;
  left: 0;
}

.table100-firstcol table {
  background-color: #fff;
}

.wrap-table100-nextcols {
  width: 100%;
  overflow: auto;
  /* padding-left: 310px; */
  padding-bottom: 28px;
}

.table100-nextcols table{
  table-layout: fixed;
}

.shadow-table100-firstcol {
  box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
  -webkit-box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
  -o-box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
  -ms-box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
}

.table100-firstcol table {
  background-color: transparent;
}

/*==================================================================
[ Ver1 ]*/

.table100.ver1 th {
  font-family: "CW BR Firma",sans-serif;
  font-size: 14px;
  color: #333333;
  line-height: 1.4;
  font-weight: 600;
  /* text-transform: uppercase; */
}

.table100.ver1 td {
  font-family: Roboto-Medium;
  font-size: 15px;
  line-height: 1.4;
}

.table100.ver1 .table100-firstcol td {
  color: #666666;
}

.table100.ver1 .table100-nextcols td {
  color: #999999;
}

.table100.ver1 tr {
  border-bottom: 1px solid #f2f2f2;
}
.hvr:hover{
  background: #ECF0F1;
  cursor: pointer;
}
@keyframes placeHolderShimmer {
   0% {
    background: #ececec;
  }
  
  30% {
    background: #F7F7F7;
  }
 
  50% {
    background: #ececec;
  }
  
  80% {
    background: #F7F7F7;
  }
  
  100% {
    background: #ececec;
  }
}

.loading-animation {
  animation: placeHolderShimmer 3s infinite;
}
.tvv{
  display: flex; 
  flex-wrap: wrap; 
  flex-direction: column;
  height: 300px; 
  width: 100%;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  scroll-behavior: smooth;  
  justify-content: center; 
  align-items: center; 
  text-align: center;
}
.tvv2{
  /* padding-top: 3rem; */
  text-align: center; 
  height: 100%; 
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  scroll-behavior: smooth;  
}
.qrClass{
  display: flex;
  align-items: center; 
  flex-direction: column;
  margin: 0 auto;
}
.field__input{ 
  --uiFieldPlaceholderColor: var(--fieldPlaceholderColor, #767676);
  /* color: #ffffff; */
  
  background-color: transparent;
  border-radius: 0;
  border: none;

  -webkit-appearance: none;
  -moz-appearance: none;

  font-family: inherit;
  font-size: inherit;
}

.field__input:focus::-webkit-input-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

.field__input:focus::-moz-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

/*
=====
CORE STYLES
=====
*/

.field{
  --uiFieldBorderWidth: var(--fieldBorderWidth, 2px);
  --uiFieldPaddingRight: var(--fieldPaddingRight, 1rem);
  --uiFieldPaddingLeft: var(--fieldPaddingLeft, 1rem);   
  --uiFieldBorderColorActive: var(--fieldBorderColorActive, rgba(22, 22, 22, 1));

  display: var(--fieldDisplay, inline-flex);
  position: relative;
  font-size: var(--fieldFontSize, 1rem);
}

.field__input{
  box-sizing: border-box;
  width: var(--fieldWidth, 100%);
  height: var(--fieldHeight, 3rem);
  padding: var(--fieldPaddingTop, 1.25rem) var(--uiFieldPaddingRight) var(--fieldPaddingBottom, .5rem) var(--uiFieldPaddingLeft);
  border-bottom: var(--uiFieldBorderWidth) solid var(--fieldBorderColor, rgba(0, 0, 0, .25));  
}

.field__input:focus{
  outline: none;
}

.field__input::-webkit-input-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input::-moz-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input:focus::-webkit-input-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__input:focus::-moz-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__label-wrap{
  box-sizing: border-box;
  pointer-events: none;
  cursor: text;
  /* color: #ffffff; */

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.field__label-wrap::after{
  content: "";
  box-sizing: border-box;
  width: 100%;
  height: 0;
  opacity: 0;

  position: absolute;
  bottom: 0;
  left: 0;
}

.field__input:focus ~ .field__label-wrap::after{
  opacity: 1;
}

.field__label{
  position: absolute;
  left: var(--uiFieldPaddingLeft);
  top: calc(50% - .5em);

  line-height: 1;
  font-size: var(--fieldHintFontSize, inherit);

  transition: top .2s cubic-bezier(0.9, -0.15, 0.1, 1.15), opacity .2s ease-out, font-size .2s ease-out;
  will-change: bottom, opacity, font-size;
}

.field__input:focus ~ .field__label-wrap .field__label,
.field__input:not(:placeholder-shown) ~ .field__label-wrap .field__label{
  --fieldHintFontSize: var(--fieldHintFontSizeFocused, .75rem);

  top: var(--fieldHintTopHover, .25rem);
}

/* 
effect 1
*/

.field_v1 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transition: opacity .2s ease-out;
  will-change: opacity;
}

/* 
effect 2
*/

.field_v2 .field__label-wrap{
  overflow: hidden;
}

.field_v2 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transform: translate3d(-105%, 0, 0);
  will-change: transform, opacity;
  transition: transform .285s ease-out .2s, opacity .2s ease-out .2s;
}

.field_v2 .field__input:focus ~ .field__label-wrap::after{
  transform: translate3d(0, 0, 0);
  transition-delay: 0;
}

/*
effect 3
*/

.field_v3 .field__label-wrap::after{
  border: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  will-change: opacity, height;
  transition: height .2s ease-out, opacity .2s ease-out;
}

.field_v3 .field__input:focus ~ .field__label-wrap::after{
  height: 100%;
}

/*
=====
LEVEL 4. SETTINGS
=====
*/

.field{
  --fieldBorderColor: #ABEBC6;
  --fieldBorderColorActive: #239B56;
}

/*
=====
DEMO
=====
*/

.page{
  background: transparent; 
  padding-left: 6rem;
  padding-right: 6rem;
  width: 100%;
  display: grid;
  grid-gap: 30px;
}
.page2{
  background: transparent; 
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  display: grid;
  grid-gap: 30px;
}

.view-leave-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
}

.view-enter-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
    transition-delay: 0.2s;
}

.view-enter, .view-leave-to {
    opacity: 0;
}

.view-enter-to, .view-leave {
    opacity: 1;
}

.c-table table { border-spacing: 0 1rem;  }

.c-btn-sortable svg { transition: transform .15s ease-in; }
.c-btn-sortable .is-asc { transform: rotateZ(0deg); }
.c-btn-sortable .is-dsc { transform: rotateZ(180deg); }

.c-expand-section { @apply flex justify-center items-center }
.c-expand-section::before, .c-expand-section::after {
    @apply block bg-black-4;
    height: 1px;
    content: "";
    -webkit-box-flex: 1;
    flex: auto;
    background-clip: content-box;
}
.table-row-move { transition: transform 1s; }
</style>
